import React from "react";
import ConnectorPanel from "./ConnectorPanel";

// Syncro.
//
// Two values: the account's subdomain and an API token. Every Syncro account lives on its
// own subdomain (acme.syncromsp.com), so the subdomain decides where the token is sent.
// The server accepts it as a single label and fixes the domain itself — pasting the whole
// address bar works, but nothing typed here can aim the token at another host.
//
// Nothing is registered on our side: the token is created inside the MSP's own Syncro
// account, so there is no platform app, no OAuth consent and no marketplace review.

const FIELDS = [
  {
    key: "subdomain",
    label: "Subdomain",
    required: true,
    help: "The \"acme\" in acme.syncromsp.com. Pasting the full address works too.",
  },
  {
    key: "api_key",
    label: "API token",
    secret: true,
    required: true,
    help: "Your profile → API Tokens → New Token. Shown once when created.",
  },
];

const HELP = {
  summary: "Match scanned hosts to Syncro assets and pull their OS and hardware detail.",
  // Syncro's UI calls these Organizations; its API still says `customers`. The panel
  // uses the word the admin sees in Syncro, so the mapping table reads naturally.
  customerNoun: "Syncro organization",
  steps: [
    "In Syncro, open your profile (top right) → API Tokens → New Token.",
    "Give it read access to Customers (shown as Organizations in Syncro) and Assets. This connector only ever reads.",
    "Copy the token — Syncro shows it once.",
    "Enter your subdomain and the token here, press Connect, then Test connection.",
  ],
};

const SyncroPanel = ({ isAdmin }) => (
  <ConnectorPanel
    isAdmin={isAdmin}
    provider="syncro"
    title="Syncro"
    fields={FIELDS}
    help={HELP}
  />
);

export default SyncroPanel;
